import { FC } from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

import Skeleton from "../Skeleton/Skeleton";
import { CardDailyPromptProps } from "./types";
import TablePrompt from "../TablePrompt/TablePrompt";
import { selectDailyAveragePromptScoresByDateState } from "../../store/selectors/scores";
import { ArrawDownIcon } from "../icons";
import useResponsive from "../../hooks/useResponsive";
import Accordion from "../Accordion";

import styles from "./CardDailyPrompt.module.css";

const CardDailyPrompt: FC<CardDailyPromptProps> = ({ prompt, index }) => {
  const { id, date } = useParams();
  const { isMobile } = useResponsive();
  const score = useSelector(selectDailyAveragePromptScoresByDateState(Number(id), Number(prompt.id), date));
  
  const renderScore = () => {
    if (score === null || !id) return <Skeleton height={56} width={88} />;

    if (score === undefined) {
      return <p className={styles.valueNoData}>No data</p>;
    }

    return score;
  }

  const renderMobileHeader = (isOpen: boolean, setIsOpen: (isOpen: boolean) => void) => {
    return (
      <div className={styles.header}>
        <h3
          className={styles.title}
          onClick={() => setIsOpen(!isOpen)}
        >
          {prompt.content}
        </h3>
        <ArrawDownIcon 
          className={styles.titleIcon} 
          data-open={isOpen ? "true" : "false"} 
        />
      </div>
    );
  };

  if (isMobile) {
    return (
      <Accordion
        defaultIsOpen
        classNameContainer={styles.root}
        classNameContent={styles.accordionContent}
        header={renderMobileHeader}
        content={() => <TablePrompt prompt={prompt} index={index} />}
      />
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          <span className={styles.titleText}>{prompt.content}</span>
        </h3>
        <div className={styles.info}>
          <p className={styles.infoLabel}>Prompt daily score</p>
          <div className={styles.value}>{renderScore()}</div>
        </div>
      </div>
      <TablePrompt prompt={prompt} index={index} />
    </div>
  );
};

export default CardDailyPrompt;